export default __webpack_public_path__ + "static/media/icon-trash-red.8bf8f669.svg";